import { gql } from '@apollo/client';

export default gql`
  mutation deleteFormDoc($_id: String) {
    deleteFormDoc(_id: $_id) {
      ok
      message
      error
    }
  }
`;
